import React from "react";

import BarChart from "components/pages/dashboard/chart/BarChart";
import useAccountAnalyticChart from "components/pages/dashboard/account_analytic/chart/useAccountAnalyticChart";

const AccountAnalyticChart = ({ data, filter }) => {
  const { options, chartData } = useAccountAnalyticChart(data, filter);

  return (
    <BarChart
      options={options}
      data={chartData}
      height={300}
      style={{ cursor: "pointer" }}
    />
  );
};

export default AccountAnalyticChart;
